import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';
import { NamedLink } from '../../../../components';

import css from './MobileHomeDock.module.css';

const MobileHomeDock = () => {
  return (
    <div className={css.dock} data-mobile-home-dock>
      <div className={css.row}>
        <NamedLink className={css.ghost} name="NewListingPage">
          <FormattedMessage id="LandingPage.mobileHome.dock.listProps" />
        </NamedLink>
        <NamedLink className={css.acc} name="SearchPage">
          <FormattedMessage id="LandingPage.mobileHome.dock.browseProps" />
        </NamedLink>
      </div>
    </div>
  );
};

export default MobileHomeDock;
